// Home Page
const myName = "Yijing Wu";

// const myTitle = "A software developer.";
const myTitle = "";

const myBriefIntro =
  "I build scalable web and mobile applications, cloud infrastructure, and intelligent systems powered by Generative AI. I love turning complex ideas into reliable, elegant solutions through code.";
// "I’m a software developer specializing in both front-end and back-end web/mobile development. Also familiar with Computer Vision and Signal Processing algorithms. I'm passionate about delivering ideas into reality via coding.";

// About Page
const myAboutMe = [
  "Hello! My name is Yijing. Welcome to my page!",
  "I’m a software engineer with hands-on experience across full-stack development, cloud DevOps, and Generative AI. I enjoy the creative process of engineering — like solving intricate puzzles — where each piece contributes to a seamless, functional system.",
  "I’m always curious about bridging the gap between AI and software engineering, leveraging LLMs and automation to build smarter, faster, and more collaborative systems.",
];

const myEducationList = [
  {
    school: "Northeastern University",
    degree: "Master",
    major: "Information Systems",
    startDate: "September 2021",
    endDate: "December 2023",
  },
  {
    school: "Tongji University",
    degree: "Bachelor",
    major: "Communication Engineering",
    startDate: "September 2017",
    endDate: "June 2021",
  },
];

const mySkillList = [
  "Python",
  "React",
  "JavaScript",
  "React Native",
  "TypeScript",
  "Node.js",
  "Docker",
  "Django",
  "CI/CD",
  "Linux",
  "Jenkins",
  "Terraform",
  "AWS",
  "Generative AI",
];

export {
  myName,
  myTitle,
  myBriefIntro,
  myAboutMe,
  myEducationList,
  mySkillList,
};
